// src/components/AnimatedBackground.jsx
export default function AnimatedBackground({ className = "" }) {
  return (
    <div className={`fixed inset-0 -z-10 overflow-hidden pointer-events-none ${className}`}>
      {/* Base gradient tint */}
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-50 via-white to-white" />

      {/* Subtle grid */}
      <div className="absolute inset-0 bg-grid opacity-50" />

      {/* Blobs (soft color glows) */}
      <div className="absolute -top-16 -left-10 h-64 w-64 rounded-full bg-indigo-300/40 blur-2xl animate-blob" />
      <div className="absolute top-24 -right-6 h-56 w-56 rounded-full bg-sky-300/40 blur-2xl animate-blobSlow" />
      <div className="absolute bottom-0 left-1/3 h-64 w-64 rounded-full bg-emerald-300/30 blur-2xl animate-blob" />

      {/* Shimmer sweep */}
      <div
        className="absolute inset-y-0 left-0 w-1/2 animate-sweep mix-blend-overlay"
        style={{ background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)" }}
      />
    </div>
  );
}
